import { useQuery } from '@apollo/client/react';

import { CAN_MANAGE_CONTRACTS } from './clauses/contractClauses.operations';

/**
 * Whether the signed-in person manages contract templates and the clauses on
 * contract records (workspace admins and owners). False until it is known, so a
 * control that would be refused never flashes up for someone who cannot use it.
 */
export function useCanManageContracts(): { canManage: boolean; loading: boolean } {
  const { data, loading } = useQuery<{ canManageContracts: boolean }>(CAN_MANAGE_CONTRACTS);
  return { canManage: data?.canManageContracts === true, loading };
}
